// Patient-portal-owned preferences (dietary preference, food tag
// exclusions, etc.). Distinct from clinic-owned identity surface
// (profilesService) — the patient writes here directly, no
// correction-request workflow.
//
// Backend: GET /api/secure/me/preferences, PATCH /api/secure/me/preferences.
// Source-of-truth on PatientPreferencesResponse:
//   {
//     patientProfileId: string,
//     dietaryPreference: 'VEGETARIAN' | 'NON_VEGETARIAN' | 'VEGAN'
//                        | 'EGGETARIAN' | 'JAIN' | 'PESCATARIAN' | null,
//     foodTagsToExclude: string[] | null   // e.g. ['GLUTEN', 'NUTS']
//   }

import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/preferencesApi'
import { patientGet, patientPatch } from './patientApi'

const PATH = '/api/secure/me/preferences'

export const DIETARY_PREFERENCE_OPTIONS = Object.freeze([
  { code: 'VEGETARIAN', label: 'Vegetarian', emoji: '🥗' },
  { code: 'NON_VEGETARIAN', label: 'Non-vegetarian', emoji: '🍗' },
  { code: 'VEGAN', label: 'Vegan', emoji: '🌱' },
  { code: 'EGGETARIAN', label: 'Eggetarian', emoji: '🥚' },
  { code: 'JAIN', label: 'Jain', emoji: '🪷' },
  { code: 'PESCATARIAN', label: 'Pescatarian', emoji: '🐟' },
])

export function dietaryPreferenceLabel(code) {
  if (!code) return 'No preference'
  const found = DIETARY_PREFERENCE_OPTIONS.find((o) => o.code === code)
  return found ? found.label : code
}

export async function getPreferences(profile) {
  if (shouldUseMocks()) return mock.getPreferences(profile)
  const res = await patientGet(PATH, {
    requirePatientContext: true,
    profileId: profile?.id,
  })
  return res?.data || null
}

/**
 * PATCH semantics — only fields present in {@code patch} are updated, the
 * rest of the row is preserved server-side. Pass {@code dietaryPreference: ''}
 * to clear (Jackson can't distinguish "absent" from "explicitly null"
 * cleanly, so backend uses empty-string-clears).
 *
 * @param {object} profile  active PatientProfile
 * @param {object} patch    e.g. { dietaryPreference: 'VEGETARIAN' }
 *                          or  { foodTagsToExclude: [] }
 */
export async function updatePreferences(profile, patch) {
  if (shouldUseMocks()) return mock.updatePreferences(profile, patch)
  const res = await patientPatch(PATH, patch || {}, {
    requirePatientContext: true,
    profileId: profile?.id,
  })
  return res?.data || null
}
